import React, { Fragment } from 'react'
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import { withTranslation } from 'react-i18next'
import { SkipContent } from '@christies/react/components/ButtonsInputs'

const V2020SkipLinks = (props) => {
  const { sitecoreContext, t } = props
  const isEditing = sitecoreContext && sitecoreContext.pageEditing

  if (isEditing) {
    return true
  }

  const skipLinksAria = t('foundation-discovery-accessibility-labels-skiplinks-aria')
  const skipLinksLabel = t('foundation-discovery-accessibility-labels-skiplinks-label')

  const returnCode = `
<div id="focusablePlaceholder" tabindex="0" onfocus="this.remove()">
    <!-- A first focusable element is focused after the cookie law banner is closed. To prevent visual issues, this element is a placeholder that's gonna be removed on focus. -->
    <script>function getCookie(e) {
      for (
        var n = e + '=',
          t = decodeURIComponent(document.cookie).split(';'),
          o = 0;
        o < t.length;
        o++
      ) {
        for (var r = t[o]; ' ' == r.charAt(0); ) r = r.substring(1)
        if (0 == r.indexOf(n)) return r.substring(n.length, r.length)
      }
      return null
    }
    if (getCookie('OptanonAlertBoxClosed')) {
      document.getElementById('focusablePlaceholder').remove()
    }</script>
</div>
`
  return (
    <Fragment>
      <div dangerouslySetInnerHTML={{ __html: returnCode }} />
      <SkipContent ariaLabel={skipLinksAria} text={skipLinksLabel} href={'#main-content'} />
    </Fragment>
  )
}

export default withSitecoreContext()(withTranslation()(V2020SkipLinks))
